import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { Link } from "react-router-dom";
import {
	ARTICLES,
	ARTICLE_ROUTES,
	FONTS,
	FONTS2,
	PURPLE,
	ROUTES,
} from "../constants";
import { Line100 } from "../dashboard/Common/BoxHeader";
import { LogoNameMainPageScrollSmaller } from "../dashboard/Common/LogoNameMainPageScroll";
import expert from "../media/expert.png";
import { stateType, stateTypeF } from "../state";

type sectionType = { id: string; sectionName: string; content: any };
export type articleType = {
	articleName: string;
	created: string;
	sections: sectionType[];
};

export const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		container: {
			fontFamily: FONTS2,
			width: "80%",
			marginLeft: "10%",
		},
		articleContainer: {
			width: "100%",
			marginLeft: "50px",
			marginTop: "30px",
		},
		login: { fontFamily: FONTS, overflow: "hidded" },
		topItems: {
			display: "flex",
			justifyContent: "space-between",

			marginTop: "-8px",
		},
		topBarContainer: {},
		articlesInThisSection: {},
		list: { listStyle: "none" },
		listItem: {
			height: "40px",
			margin: "5px",
			width: "180px",
			"&:hover": { backgroundColor: PURPLE, color: "white" },
			cursor: "pointer",
			marginLeft: "-20px",
			transition: ".2s",
			color: "black",
		},
		listItemSelected: {
			height: "40px",
			margin: "5px",
			width: "180px",
			backgroundColor: PURPLE,
			color: "white",
			cursor: "pointer",
			marginLeft: "-20px",
			transition: ".2s",
		},
		listItemText: {
			marginLeft: "10px",
			lineHeight: "40px",
			fontFamily: FONTS2,
			fontWeight: 200,
			width: "180px",
		},
		title: { fontSize: "30px", fontFamily: FONTS2, fontWeight: 300 },
		authorImage: { width: "50px", height: "50px", borderRadius: "100px" },
		madeByContainer: { display: "flex", marginTop: "30px" },
		sectionTitle: { fontSize: "30px", fontFamily: FONTS2, fontWeight: 300 },
		sectionContent: {
			fontSize: "18px",
			fontFamily: FONTS2,
			fontWeight: 200,
			marginTop: "18px",
			lineHeight: "29px",
			color: "rgba(0,0,0,0.8)",
		},
		sectionListItem: {
			fontSize: "17px",
			fontFamily: FONTS2,
			fontWeight: 200,
		},
		sectionListItemBold: {
			fontSize: "17px",
			fontFamily: FONTS2,
			fontWeight: 600,
		},
	})
);

type applicationsPageType = { state: stateTypeF; article: articleType };

export function ApplicationPage({ state, article }: applicationsPageType) {
	const classes = useStyles();
	return (
		<div className={classes.container}>
			<TopBar state={state}></TopBar>
			<div style={{ marginTop: "20px", display: "flex" }}>
				<ArticlesInThisSection state={state}></ArticlesInThisSection>
				<Article article={article} state={state}></Article>
			</div>
		</div>
	);
}

function TopBar({ state }: stateType) {
	const classes = useStyles();
	return (
		<div className={classes.topBarContainer}>
			<div className={classes.topItems}>
				<div style={{ width: "30px", height: "100px" }}>
					<LogoNameMainPageScrollSmaller></LogoNameMainPageScrollSmaller>
				</div>
				<Link to={ROUTES.login} style={{ textDecoration: "none" }}>
					<div
						className={classes.login}
						style={{ marginTop: "30px", color: "black" }}
					>
						Log In
					</div>
				</Link>
			</div>
			<div style={{ marginTop: "-30px", width: "100vw" }}>
				<Line100></Line100>
			</div>
		</div>
	);
}

function ArticlesInThisSection({ state }: stateType) {
	const classes = useStyles();
	const articles = Object.values(ARTICLES);

	return (
		<div className={classes.articlesInThisSection}>
			<h3 style={{ fontSize: "18px", fontWeight: 400 }}>
				Use Case Examples
			</h3>
			<ul className={classes.list}>
				{articles.map((article) => {
					return (
						<Link
							to={ARTICLE_ROUTES[article]}
							style={{ textDecoration: "none", width: "100px" }}
						>
							<li
								className={
									state.articleApplicationSelected === article
										? classes.listItemSelected
										: classes.listItem
								}
								style={{ textDecoration: "none" }}
								onClick={() =>
									state.setArticleApplicationSelected(article)
								}
							>
								<div className={classes.listItemText}>
									{article}
								</div>
							</li>
						</Link>
					);
				})}
			</ul>
		</div>
	);
}

type articleINputType = { article: articleType };
type articleINputType2 = { article: articleType; state: stateTypeF };
function Article({ article, state }: articleINputType2) {
	const classes = useStyles();
	const title = "Case Study: " + article.articleName;

	return (
		<div className={classes.articleContainer}>
			<div className={classes.title}>{title}</div>
			<MadeBy article={article}></MadeBy>
			<QuickLinks article={article}></QuickLinks>
			<ArticleContent article={article}></ArticleContent>
		</div>
	);
}

function MadeBy({ article }: articleINputType) {
	const classes = useStyles();
	return (
		<div className={classes.madeByContainer}>
			<img
				src={"https://batch-32.imgix.net/expert.png"}
				className={classes.authorImage}
			></img>
			<div
				style={{
					fontFamily: FONTS2,
					fontSize: "17px",
					color: "rgba(0,0,0,0.9)",
					marginTop: "5px",
					marginLeft: "10px",
				}}
			>
				<div>Alex Vukadinovic</div>
				<div
					style={{
						color: "rgba(0,0,0,0.6)",
						fontSize: "14px",
					}}
				>
					{article.created} • modified
				</div>
			</div>
		</div>
	);
}

function QuickLinks({ article }: articleINputType) {
	return (
		<div>
			<div
				style={{
					fontFamily: FONTS2,
					fontWeight: 500,
					fontSize: "20px",
					marginBottom: "20px",
					marginTop: "20px",
				}}
			>
				Article Sections:
			</div>
			<ul>
				{article.sections.map((section) => (
					<li
						style={{
							fontFamily: FONTS2,
							fontWeight: 200,
							marginBottom: "5px",
							cursor: "pointer",
						}}
						onClick={() =>
							document.getElementById(section.id).scrollIntoView()
						}
					>
						{section.sectionName}
					</li>
				))}
			</ul>
		</div>
	);
}

type sectionInput = { section: sectionType };
function ArticleSection({ section }: sectionInput) {
	const classes = useStyles();
	let Content = section.content;
	return (
		<div style={{ marginTop: "50px" }}>
			<div id={section.id} className={classes.sectionTitle}>
				{section.sectionName}
			</div>
			<Content></Content>
		</div>
	);
}

function ArticleContent({ article }: articleINputType) {
	const classes = useStyles();
	return (
		<div style={{ marginTop: "30px" }}>
			{article.sections.map((section) => (
				<ArticleSection section={section}></ArticleSection>
			))}
		</div>
	);
}
